import { defineMessages } from "react-intl";

export const messages = defineMessages({
  absoluteTimeRange: {
    id: "ari.management.absoluteTimeRange",
    defaultMessage: "See calendar from"
  },
  from: {
    id: "ari.management.from",
    defaultMessage: "From"
  },
  apply: {
    id: "ari.management.view",
    defaultMessage: "View"
  }
});